var map = {
	"./ABBank.png": 3245,
	"./ACB.png": 32587,
	"./Agribank.png": 70971,
	"./BIDV.png": 16024,
	"./BVBank.png": 61449,
	"./Bacabank.png": 43800,
	"./HDBank.png": 78230,
	"./MBbank.png": 47123,
	"./NamAbank.png": 41759,
	"./Sacombank.png": 10654,
	"./SeAbank.png": 93637,
	"./TPBank.png": 74028,
	"./Techcombank.png": 39151,
	"./VIB.png": 38365,
	"./VPBank.png": 34057,
	"Common/Components/AppFooter/Assets/Icons/Vn/ABBank.png": 3245,
	"Common/Components/AppFooter/Assets/Icons/Vn/ACB.png": 32587,
	"Common/Components/AppFooter/Assets/Icons/Vn/Agribank.png": 70971,
	"Common/Components/AppFooter/Assets/Icons/Vn/BIDV.png": 16024,
	"Common/Components/AppFooter/Assets/Icons/Vn/BVBank.png": 61449,
	"Common/Components/AppFooter/Assets/Icons/Vn/Bacabank.png": 43800,
	"Common/Components/AppFooter/Assets/Icons/Vn/HDBank.png": 78230,
	"Common/Components/AppFooter/Assets/Icons/Vn/MBbank.png": 47123,
	"Common/Components/AppFooter/Assets/Icons/Vn/NamAbank.png": 41759,
	"Common/Components/AppFooter/Assets/Icons/Vn/Sacombank.png": 10654,
	"Common/Components/AppFooter/Assets/Icons/Vn/SeAbank.png": 93637,
	"Common/Components/AppFooter/Assets/Icons/Vn/TPBank.png": 74028,
	"Common/Components/AppFooter/Assets/Icons/Vn/Techcombank.png": 39151,
	"Common/Components/AppFooter/Assets/Icons/Vn/VIB.png": 38365,
	"Common/Components/AppFooter/Assets/Icons/Vn/VPBank.png": 34057
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48185;